import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Tenía $180.000 repartidos en distintas cuentas sin rendir nada. Con la cascada del Tomo 1 moví todo y en el primer mes generé $22.000 de rendimiento sin hacer absolutamente nada. Eso antes iba a la inflación.',
    author: 'Carlos M.',
    location: 'Empleado · Buenos Aires',
    initial: 'C'
  }, {
    quote: 'El truco del supermercado me cambió la vida. Antes gastaba $95.000 por semana. Con la lista cerrada, la promo del día y las marcas blancas, bajé a $58.000. El mismo nivel de comida, $37.000 menos por semana.',
    author: 'Valeria G.',
    location: 'Docente · Córdoba',
    initial: 'V'
  }, {
    quote: 'Llevaba 4 años sin un solo dólar ahorrado. Me parecía imposible con mi sueldo. Con el Tomo 3 arranqué con el DCA de $8.000 por mes. Hoy tengo U$S 340 acumulados y no paro.',
    author: 'Martín F.',
    location: 'Comerciante · Rosario',
    initial: 'M'
  }, {
    quote: 'La negociación del Tomo 4 me salvó. Llamé al banco con el guión exacto, logré una quita del 35% en una deuda que tenía desde hace dos años. Nunca pensé que se podía hacer eso.',
    author: 'Laura P.',
    location: 'Autónoma · Mendoza',
    initial: 'L'
  }, {
    quote: 'Con el Tomo 5 empecé a ofrecer diseños en Canva a negocios del barrio. En 3 semanas tenía 2 clientes fijos. En el mes 4 cerré mi primera retención de $90.000 mensuales. Era plata que antes no existía.',
    author: 'Agustín R.',
    location: 'Empleado y freelance · Santa Fe',
    initial: 'A'
  }, {
    quote: 'El Protocolo 911 del Tomo 6 me salvó en el peor mes financiero de mi vida. En lugar de entrar en pánico y tomar el primer préstamo que apareció, seguí los pasos. Salí de la crisis sin deuda nueva.',
    author: 'Fernanda C.',
    location: 'Monotributista · Buenos Aires',
    initial: 'F'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#22c55e] mb-3 md:mb-6" data-id="element-382">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(34,197,94,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-383" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#f8fafc]" data-id="element-384">
      <FadeIn data-id="element-385">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-386">
          <span className="text-[#ef4444] drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-387">
            ❤️
          </span>{' '}
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-388">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-389">
            <motion.div whileHover={{
          y: -5
        }} className="bg-white border border-[#e2e8f0] hover:border-[#22c55e]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-390">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-391" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-392">
                <Stars data-id="element-393" />
                <p className="text-base md:text-xl text-[#0f172a] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-394">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e2e8f0]" data-id="element-395">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#22c55e] to-[#4ade80] rounded-full flex items-center justify-center text-[#020617] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(34,197,94,0.3)]" data-id="element-396">
                    {t.initial}
                  </div>
                  <div data-id="element-397">
                    <p className="font-black text-[#0f172a] text-base md:text-lg" data-id="element-398">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-399">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}